<div class="container">
    <h3 class="">Get In Loser, <br>We're going Plant Shopping</h3>
    <div class="form">
        <div class="form-inline">
            <form #form="ngForm" autocomplete="off" (submit)="onSubmit(form)">

                <input type="hidden" name="id" #id="ngModel" [(ngModel)]="wlservice.formData.id">

                <div class="input-submit">
                    <div class="form-group">
                        <input name="name" #name="ngModel" [(ngModel)]="wlservice.formData.name" class="formControl"
                            placeholder="Plant Name" required>
                        <div *ngIf="name.invalid && name.touched" class="validation-error">Plant name is required.</div>
                    </div>


                    <div class="form-group">
                        <button type="submit" [disabled]="form.invalid"
                            class="btn btn-lg btn-block btn btn-outline-success">Submit</button>
                    </div>
                </div>
            </form>
                     <div class="error" *ngIf="message">
                         <h5 class="text-success">{{ message }}</h5>
                      </div>
        </div>


    </div>
    <!-- <div class="error" *ngIf="message">
        <h5 class="text-success">{{ message }}</h5>
    </div> -->
</div>
<div class="list">
    <app-wishlist-list></app-wishlist-list>
</div>